const moduleTrain={
    state: {
        trainid:''
    },
    mutations: {
        SET_TRAINID:(state,payload)=>{
            state.trainid=payload.trainid
        }
    }
}

export default moduleTrain